// extracted by mini-css-extract-plugin
export default {"LoginLayout":"LoginBackground_LoginLayout__hHOmL","Overlay":"LoginBackground_Overlay__g5RcH","BackgroundImage":"LoginBackground_BackgroundImage__IIT1F"};